import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select, InputNumber, Checkbox } from 'antd';
import dayjs from 'dayjs';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getSalaryAdditionDetails, doSalaryAdditionCreate, doSalaryAdditionUpdate 
} from "../../../../redux/salaryaddition/salaryAdditionState";
import { useForm } from 'antd/lib/form/Form';
import SelectWithOthers from "components/select/selectwithothers";
import { requiredField } from '../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

const SalaryAdditionForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			
			const { sdn_start_date, sdn_end_date, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	            sdn_start_date: sdn_start_date ? dayjs(sdn_start_date, dateFormat) : null,
			    sdn_end_date: sdn_end_date ? dayjs(sdn_end_date, dateFormat) : null,
			    effective_date: [sdn_start_date ? dayjs(sdn_start_date, dateFormat) : null, sdn_end_date ? dayjs(sdn_end_date, dateFormat) : null]
	        };
			
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  
			const { effective_date, ...forSubmitValues } = values;			  
			forSubmitValues.sdn_start_date = effective_date[0].format('YYYY-MM-DD');
			forSubmitValues.sdn_end_date = effective_date[1].format('YYYY-MM-DD');	
			forSubmitValues.sdn_first_cutoff = forSubmitValues.sdn_first_cutoff ? 1 : 0;
			forSubmitValues.sdn_second_cutoff = forSubmitValues.sdn_second_cutoff ? 1 : 0;
			recordData.sdn_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
			
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="sdn_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-4">
        			<FormItem className="font-medium mb-2"
		            	name="sdn_employee_id"
		                label="Employee"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdn_employee_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.employeeList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdn_employee_name}</label>
		            	}	                
	            	</FormItem> 
	            	<FormItem className="font-medium mb-2"
		            	name="effective_date"
		                label="Effective Date"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<RangePicker className="font-normal"
		            		format={dateFormat}
		            		style={{
						        width: 250,
						      }}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.sdn_start_date} to {recordData?.sdn_end_date}</label>
		            	}	                
	            	</FormItem>     		            
	            	
	            	<FormItem className="font-medium mb-2 col-span-2"
		            	name="sdn_paycode_id"
		                label="Paycode"
		                rules={[requiredField()]}
		            >
		            	<SelectWithOthers 
		            		mode={mode}
		            		selectFieldName="sdn_paycode_id" 
		            		selectOptions={recordData?.paycodeList} 
		            		selectDisplayValue={recordData?.sdn_paycode_name}
  							othersFieldName="sdn_other_specific"
  							othersDisplayValue={recordData?.sdn_other_specific}
  							optionOthersId={[91,92]}
		            	/>
	            	
    				</FormItem>
	            	
	            	<FormItem className="font-medium mb-2"
		            	name="sdn_total_amount"
		                label="Total Amount"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?		            			            	
		            	<InputNumber precision={2}
		                    id="sdn_total_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_total_amount}</label>
		                }
	            	</FormItem>	
	            	<FormItem className="font-medium mb-2"
		            	name="sdn_per_cutoff_amount"
		                label="Addition Per Cut-Off"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?		            			            	
		            	<InputNumber precision={2}
		                    id="sdn_per_cutoff_amount"
		                    className="aligned-right-number"
		            		style={{
						        width: 150,
						      }}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_per_cutoff_amount}</label>
		                }
	            	</FormItem>
	            	
	            	<FormItem className="font-medium mb-2"
		            	name="sdn_first_cutoff"
		                label="Include in First Cut-Off"
		                valuePropName="checked"
		            >
		            	{mode === 'edit' ?		            			            	
		            	<Checkbox />
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_first_cutoff === 1 ? 'Yes' : 'No'}</label>
		                }
	            	</FormItem>	            	
	            	<FormItem className="font-medium mb-2"
		            	name="sdn_second_cutoff"
		                label="Include in Second Cut-Off"
		                valuePropName="checked"
		            >
		            	{mode === 'edit' ?		            			            	
		            	<Checkbox />
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_second_cutoff === 1 ? 'Yes' : 'No'}</label>
		                }
	            	</FormItem>
	            	
					<FormItem className="font-medium mb-2"
		            	name="sdn_type_id"
		                label="Payroll Type"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdn_type_id"
		            		style={{
						        width: 150,
						      }}
						      options={recordData?.payrollTypeList}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_type_name}</label>
		                }
	            	</FormItem>
					
	            	<FormItem className="font-medium mb-2"
		            	name="sdn_status_id"
		                label="Status"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="sdn_status_id"
		            		style={{
						        width: 150,
						      }}
						      options={recordData?.statusList}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_status_name}</label>
		                }
	            	</FormItem>
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="sdn_notes"
		                label="Notes"
		                initialValue={recordData?.sdn_notes}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		maxLength={500}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.sdn_notes}</label>
		                }
	            	</FormItem>
	 			</div>	 	
	 			<CrudButtons baseRoute="/console/salary-additions" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.salaryAddition.salaryAdditionDetails?.data,
  	requesting: state.salaryAddition.salaryAdditionDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getSalaryAdditionDetails(id)),
  	doCreate: (data) => dispatch(doSalaryAdditionCreate(data)),
  	doUpdate: (data) => dispatch(doSalaryAdditionUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryAdditionForm);
